import { render, staticRenderFns } from "./ItemGroup.vue?vue&type=template&id=3673999e&"
import script from "./ItemGroup.vue?vue&type=script&lang=ts&"
export * from "./ItemGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ItemGroup.vue?vue&type=style&index=0&id=3673999e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports